import { Component } from 'react';
import {deleteUserGroup} from '../../../../actions/usergroups';
import store, {history} from '../../../../store';
import IgniteDataTable from '../../../common/datatable';
import ConfirmPopup from '../../../common/confirm-popup';

class UserGroupsList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      delete: {
        show: false
      }
    };
  }

  render() {
    const columns = [
      {
        prop: 'name',
        title: 'Name'
      },
      {
        prop: 'num-of-users',
        title: 'Users'
      },
      {
        prop: 'num-of-permissions',
        title: 'Permissions'
      },
    ];

    const actions = [
      {
        label: 'Edit',
        color: 'grey',
        permissions: {
          action: 'update',
          subjectClass: 'UserGroup'
        },
        callback: (row) => {
          history.push(`/admin/user-groups/${row.id}`);
        }
      },
      {
        label: 'Delete',
        permissions: {
          action: 'destroy',
          subjectClass: 'UserGroup'
        },
        disabled: (row) => {
          const numOfUsers = row.attributes['num-of-users'];
          const groupDeletable = row.attributes.deletable;
          return numOfUsers > 0 || !groupDeletable;
        },
        callback: (row) => {
          this.setState({
            delete: {
              show: true,
              id: row.id
            }
          });
        }
      }
    ];

    const handleDelete = (result) => {
      const {id} = this.state.delete;
      this.setState({delete: {show: false}});
      if (result) {
        store.dispatch(deleteUserGroup(id));
      }
    };

    return (
      <div>
        <IgniteDataTable
          actions={actions}
          columns={columns}
          data={this.props.userGroups}
        />

        {
          this.state.delete.show && (
            <ConfirmPopup
              header="DELETE USER GROUP?"
              onClose={handleDelete}
            >
              <p>
                Are you sure you want to delete the selected usergroup?
              </p>
            </ConfirmPopup>
          )}
      </div>
    );
  }
}

export default UserGroupsList;
